import { registerPlugin } from '@capacitor/core';
const AdmobAds = registerPlugin('AdmobAds', {
    web: () => import('./web').then(m => new m.AdmobAdsWeb()),
});
export * from './definitions';
export { AdmobAds };
//# sourceMappingURL=index.js.map